export const reachGallery = () => {
  const handleMouseMove = function (e) {
    var width = $(window).width(),
      height = $(window).height(),
      offsetX = 0.5 - e.pageX / width,
      offsetY = 0.5 - e.pageY / height,
      $parallaxItem = $('.wp-block-image');

    $('.pattern-reach-gallery .wp-block-image').each(function (i, el) {
      var offset = (i + 1) * 10,
        translate =
          'translate3d(' +
          Math.round(offsetX * offset) +
          'px,' +
          Math.round(offsetY * offset) +
          'px,0px)';
      $(el).css({
        '-webkit-transform': translate,
        transform: translate,
        '-moz-transform': translate,
      });
    });
  };

  $(document).on('mousemove', handleMouseMove);
  $(document).on('scroll', handleMouseMove);
};
